import React, { useState, useEffect } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { Broker } from 'models';
import { useIntl } from 'react-intl';
import { COLOR } from 'config/constants';
import PortalHeader from './PortalHeader';

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 30,
  },
  videoContainer: {
    '@media (max-width: 900px)': {
      height: 600,
    },
    '@media (max-width: 820px)': {
      height: 500,
      objectFit: 'cover',
    },
    '@media (max-width: 700px)': {
      height: 450,
      objectFit: 'cover',
    },
  },
  slogan: {
    fontWeight: 'bold',
    fontSize: 35,
    marginBottom: 50,
    color: COLOR.WHITE,
    '@media (max-width: 700px)': {
      fontSize: 20,
      marginBottom: 40,
      marginLeft: 5,
      marginRight: 5,
    },
  },
  stickyHeader: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: 'auto',
    backgroundColor: COLOR.WHITE,
    zIndex: 999,
  },
  sloganContent: {
    position: 'absolute',
    textAlign: 'center',
    bottom: 50,
    zIndex: 3,
    '@media (max-width: 1024px)': {
      bottom: 0,
    },
    '@media (max-width: 700px)': {
      bottom: 0,
    },
  },
});
interface Props {
  broker: Broker;
  slogan: string;
  logo_picture_url?: string;
  portal_infos: any;
  sections?: any;
  showPortalHeader?: boolean;
  favorite_listings: any;
  is_white_text?: boolean;
}
function VideoHeader(props: Props) {
  const {
    broker,
    slogan,
    logo_picture_url,
    portal_infos,
    sections,
    showPortalHeader,
    favorite_listings,
    is_white_text,
  } = props;
  const styles = useStyles();
  const intl = useIntl();

  return (
    <Box>
      <Box className={styles.stickyHeader}>
        {showPortalHeader ? (
          <PortalHeader
            displaySocialMedia
            logo_picture_url={logo_picture_url}
            portal_infos={portal_infos}
            broker={broker}
            sections={sections}
            favorite_listings={favorite_listings}
            is_white_text={is_white_text}
          />
        ) : null}
      </Box>
      <Box className={styles.banner}>
        <video
          className={styles.videoContainer}
          width='100%'
          height='100%'
          loop
          muted
          autoPlay
          playsInline
          preload='auto'
        >
          <source src={portal_infos?.banner_video} type='video/mp4' />
        </video>
        <div className={styles.sloganContent}>
          <Typography className={styles.slogan}>{slogan || null}</Typography>
        </div>
      </Box>
    </Box>
  );
}

export default VideoHeader;
